import React, { useState } from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { useScrollReveal } from '../hooks/useScrollReveal';

const Contact = () => {
  useScrollReveal();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    role: '',
    interest: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        organization: '',
        role: '',
        interest: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <>
      <Nav />
      
      <section className="hero-dark">
        <div className="grid-bg"></div>
        <div className="hero-dark-inner">
          <div className="pill reveal in">
            <span>✦</span> We're here to help modernize your agency
          </div>
          <h1 className="reveal in">Let's build something mission-ready together.</h1>
          <p className="sub reveal in">
            Whether you're exploring Valor for the first time or ready to deploy, our team is standing by to answer questions and design a solution that fits your mandate.
          </p>
        </div>
      </section>

      <section style={{paddingTop: '80px', paddingBottom: '120px'}}>
        <div className="wrap">
          <div className="contact-layout">
            {/* Contact Form */}
            <div className="contact-form-wrapper reveal">
              <div className="contact-form-header">
                <h2>Get in touch</h2>
                <p>Fill out the form below and we'll get back to you within one business day.</p>
              </div>

              {submitted ? (
                <div className="form-success">
                  <div className="success-icon">✓</div>
                  <h3>Thank you for reaching out!</h3>
                  <p>We've received your message and will respond shortly.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Jane Smith"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Work Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="jane@agency.gov"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="organization">Organization *</label>
                      <input
                        type="text"
                        id="organization"
                        name="organization"
                        value={formData.organization}
                        onChange={handleChange}
                        required
                        placeholder="State Health Agency"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="role">Your Role</label>
                      <input
                        type="text"
                        id="role"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        placeholder="Director of IT"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="interest">What are you interested in? *</label>
                    <select
                      id="interest"
                      name="interest"
                      value={formData.interest}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select an option</option>
                      <option value="valor-os">Valor OS Platform</option>
                      <option value="counterops">CounterOps Suite</option>
                      <option value="apps">Custom Applications</option>
                      <option value="demo">Schedule a Demo</option>
                      <option value="partnership">Partnership Opportunities</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us about your project, timeline, and any specific requirements..."
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-accent btn-full">
                    Send Message <span className="arrow">→</span>
                  </button>

                  <p className="form-note">
                    By submitting this form, you agree to our privacy policy and terms of service.
                  </p>
                </form>
              )}
            </div>

            {/* Contact Info Sidebar */}
            <div className="contact-sidebar">
              <div className="contact-card reveal" style={{transitionDelay: '0.1s'}}>
                <div className="contact-card-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <h3>Headquarters</h3>
                <p>
                  1800 F Street NW<br/>
                  Washington, DC 20006<br/>
                  United States
                </p>
              </div>

              <div className="contact-card reveal" style={{transitionDelay: '0.2s'}}>
                <div className="contact-card-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <h3>Email</h3>
                <p>
                  <a href="mailto:hello@valortechnyx.com">hello@valortechnyx.com</a><br/>
                  <a href="mailto:support@valortechnyx.com">support@valortechnyx.com</a>
                </p>
              </div>

              <div className="contact-card reveal" style={{transitionDelay: '0.3s'}}>
                <div className="contact-card-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <h3>Phone</h3>
                <p>
                  Sales: <a href="tel:+12025551234">+1 (202) 555-1234</a><br/>
                  Support: <a href="tel:+12025555678">+1 (202) 555-5678</a>
                </p>
              </div>

              <div className="contact-card reveal" style={{transitionDelay: '0.4s'}}>
                <div className="contact-card-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <h3>Business Hours</h3>
                <p>
                  Monday - Friday<br/>
                  9:00 AM - 6:00 PM EST<br/>
                  <span style={{fontSize: '13px', color: 'var(--muted)'}}>Emergency support available 24/7</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="fog-section">
        <div className="wrap">
          <div className="section-head reveal">
            <span className="eyebrow">Common Questions</span>
            <h2>Frequently Asked Questions</h2>
          </div>

          <div className="faq-grid reveal-stagger">
            <div className="faq-item">
              <h3>How long does implementation typically take?</h3>
              <p>Most agencies are up and running within 8-12 weeks, depending on scope and integration requirements. We work closely with your team to ensure a smooth transition.</p>
            </div>
            <div className="faq-item">
              <h3>Is Valor compliant with federal security standards?</h3>
              <p>Yes. Valor is built to align with FedRAMP, NIST 800-53, and state-level security frameworks. Every deployment includes comprehensive audit trails and compliance documentation.</p>
            </div>
            <div className="faq-item">
              <h3>Can Valor integrate with our existing systems?</h3>
              <p>Absolutely. Valor OS is designed to work alongside your current infrastructure, with pre-built connectors for common government systems and a flexible API for custom integrations.</p>
            </div>
            <div className="faq-item">
              <h3>What kind of support do you provide?</h3>
              <p>We offer dedicated support channels, comprehensive documentation, training programs, and 24/7 emergency assistance for mission-critical deployments.</p>
            </div>
            <div className="faq-item">
              <h3>Do you offer demos or trial periods?</h3>
              <p>Yes! We provide customized demos tailored to your agency's specific use case, and can arrange sandbox environments for evaluation purposes.</p>
            </div>
            <div className="faq-item">
              <h3>How is pricing structured?</h3>
              <p>Pricing is based on your agency's size, deployment scope, and specific requirements. Contact us for a detailed quote tailored to your needs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="wrap">
          <div className="cta-band reveal">
            <h2>Ready to modernize your agency?</h2>
            <p>Join the growing number of government organizations delivering better services with Valor.</p>
            <div className="hero-ctas">
              <a href="#contact" className="btn btn-accent">Schedule a Demo <span className="arrow">→</span></a>
              <a href="/valor-os" className="btn btn-outline" style={{background: 'rgba(255,255,255,.15)', borderColor: 'rgba(255,255,255,.3)', color: '#fff'}}>
                Explore Platform <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;
